import languageIcon from '../../assets/icons/language.svg';

export default function LanguageIcon({ className }: { className?: string }) {
  return (
    <img
      src={languageIcon}
      alt="Change Language Icon"
      className={className}
    />
  );
}
